import { Box, Container } from "@mui/material";
import Header from "../Header";
import Navigation from "../Navigation";

const PageLayout = ({ children }: any) => {
  return (
    <Box display="flex" flexDirection="column" height="100vh">
      <Header />
      <Box className="content-wrapper">
        <Navigation />
        <Box component="main" className="main-wrapper">
          <Container>{children}</Container>
        </Box>
      </Box>
    </Box>
  );
};

export default PageLayout;
